const DISCORD_CLIENT_ID = '1327773225995993191';
const getRedirectUri = (type = 'discord') => {
  // Use window.location.origin to get the full origin (protocol + hostname + port)
  const origin = window.location.origin;
  return `${origin}${process.env.PUBLIC_URL || ""}/${type}/callback/`;
};

class DiscordAuthService {
  static getAuthUrl(type = 'discord') {
    const redirectUri = getRedirectUri(type);
    const authUrl = `https://discord.com/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=identify`;
    
    return authUrl;
  }

  static async exchangeCodeForToken(code, type = 'discord') {
    try {
      const redirectUri = getRedirectUri(type);
      // Exchanged server-side (src/api/discord.py) so the client secret stays out of the browser.
      const response = await fetch(`${process.env.PUBLIC_URL || ''}/api/discord/token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code, redirect_uri: redirectUri })
      });

      if (!response.ok) {
        const errorData = await response.text();
        console.error('Token exchange failed:', {
          status: response.status,
          statusText: response.statusText,
          error: errorData
        });
        throw new Error(`Failed to exchange code for token: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error exchanging code for token:', error);
      // Continue with getUserInfo even if token exchange fails
      return { access_token: code };
    }
  }

  static async getUserInfo(accessToken) {
    try {
      const response = await fetch('https://discord.com/api/users/@me', {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to get user info');
      }

      return await response.json();
    } catch (error) {
      console.error('Error getting user info:', error);
      throw error;
    }
  }

  static async getDiscordUserData(code, type = 'minecraft') {
    try {
      const tokenData = await this.exchangeCodeForToken(code, type);
      if (!tokenData.access_token) {
        throw new Error('No access token received');
      }

      const userData = await this.getUserInfo(tokenData.access_token);
      return userData;
    } catch (error) {
      console.error('Error getting Discord user data:', error);
      throw error;
    }
  }
}

export default DiscordAuthService;